<template>
  <div class="trainingPage">
    <h1 class="text-center">Training</h1>
    <div class="row">
      <div class="col-md-12">
        <h2 class="text-center">Welcome Aboard Watch This First</h2>
        <div class="videoWrapper mt-4">
          <iframe
            src="https://player.vimeo.com/video/446516893?autoplay=false&loop=1&title=0&byline=0&portrait=0"
            style="position:absolute;top:0;left:0;width:100%;height:100%;"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="col-md-12 wrapper">
        <h2 class="text-center">Setting Up Your Digital Agency</h2>
        <div class="videoWrapper mt-4">
          <iframe
            src="https://player.vimeo.com/video/740109569?autoplay=false&loop=1&title=0&byline=0&portrait=0"
            style="position:absolute;top:0;left:0;width:100%;height:100%;"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="col-md-12 wrapper">
        <h2 class="text-center">Assigning A Number To Your Digital Agency</h2>
        <div class="videoWrapper mt-4">
          <iframe
            src="https://player.vimeo.com/video/740111549?autoplay=false&loop=1&title=0&byline=0&portrait=0"
            style="position:absolute;top:0;left:0;width:100%;height:100%;"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="col-md-12 wrapper">
        <h2 class="text-center">Getting To Know Your DFY Campaigns</h2>
        <div class="videoWrapper mt-4">
          <iframe
            src="https://player.vimeo.com/video/740113511?autoplay=false&loop=1&title=0&byline=0&portrait=0"
            style="position:absolute;top:0;left:0;width:100%;height:100%;"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="col-md-12 wrapper">
        <h2 class="text-center">Getting To Know Your Automation and Follow Up Sequence</h2>
        <div class="videoWrapper mt-4">
          <iframe
            src="https://player.vimeo.com/video/740117924?autoplay=false&loop=1&title=0&byline=0&portrait=0"
            style="position:absolute;top:0;left:0;width:100%;height:100%;"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="col-md-12 wrapper">
        <h2 class="text-center">How To Update Your Billing For SMS</h2>
        <div class="videoWrapper mt-4">
          <iframe
            src="https://player.vimeo.com/video/740126234?autoplay=false&loop=1&title=0&byline=0&portrait=0"
            style="position:absolute;top:0;left:0;width:100%;height:100%;"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="col-md-12 wrapper">
        <h2 class="text-center">Agency Whitelabel Custom URL</h2>
        <div class="videoWrapper mt-4">
          <iframe
            src="https://player.vimeo.com/video/446519077?autoplay=false&loop=1&title=0&byline=0&portrait=0"
            style="position:absolute;top:0;left:0;width:100%;height:100%;"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="col-md-12 wrapper">
        <h2 class="text-center">Install The Widget On A Website</h2>
        <div class="videoWrapper mt-4">
          <iframe
            src="https://player.vimeo.com/video/515452572?autoplay=false&loop=1&title=0&byline=0&portrait=0"
            style="position:absolute;top:0;left:0;width:100%;height:100%;"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="col-md-12 wrapper">
        <h2 class="text-center">Install The Widget On A Single Page</h2>
        <div class="videoWrapper mt-4">
          <iframe
            src="https://player.vimeo.com/video/453745125?autoplay=false&loop=1&title=0&byline=0&portrait=0"
            style="position:absolute;top:0;left:0;width:100%;height:100%;"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="col-md-12 wrapper">
        <h2 class="text-center">Redemption Page Training</h2>
        <div class="videoWrapper mt-4">
          <iframe
            src="https://player.vimeo.com/video/446538958?autoplay=false&loop=1&title=0&byline=0&portrait=0"
            style="position:absolute;top:0;left:0;width:100%;height:100%;"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="col-md-12 wrapper">
        <h2 class="text-center">Campaign Overview</h2>
        <div class="videoWrapper mt-4">
          <iframe
            src="https://player.vimeo.com/video/525768974?autoplay=false&loop=1&title=0&byline=0&portrait=0"
            style="position:absolute;top:0;left:0;width:100%;height:100%;"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="col-md-12 wrapper">
        <h2 class="text-center">How To Setup Your Widget</h2>
        <div class="videoWrapper mt-4">
          <iframe
            src="https://player.vimeo.com/video/745126201?autoplay=false&loop=1&title=0&byline=0&portrait=0"
            style="position:absolute;top:0;left:0;width:100%;height:100%;"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="col-md-12 wrapper">
        <h2 class="text-center">Contact Overview</h2>
        <div class="videoWrapper mt-4">
          <iframe
            src="https://player.vimeo.com/video/525760876?autoplay=false&loop=1&title=0&byline=0&portrait=0"
            style="position:absolute;top:0;left:0;width:100%;height:100%;"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="col-md-12 wrapper">
        <h2 class="text-center">SMS Broadcast Overview</h2>
        <div class="videoWrapper mt-4">
          <iframe
            src="https://player.vimeo.com/video/446546947?autoplay=false&loop=1&title=0&byline=0&portrait=0"
            style="position:absolute;top:0;left:0;width:100%;height:100%;"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="col-md-12 wrapper">
        <h2 class="text-center">Automations Overview</h2>
        <div class="videoWrapper mt-4">
          <iframe
            src="https://player.vimeo.com/video/481802962?autoplay=false&loop=1&title=0&byline=0&portrait=0"
            style="position:absolute;top:0;left:0;width:100%;height:100%;"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="col-md-12 wrapper">
        <h2 class="text-center">Internation Twilio Setup</h2>
        <div class="videoWrapper mt-4">
          <iframe
            src="https://player.vimeo.com/video/453730648?autoplay=false&loop=1&title=0&byline=0&portrait=0"
            style="position:absolute;top:0;left:0;width:100%;height:100%;"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="col-md-12 wrapper">
        <h2 class="text-center">How to Use Meta Data</h2>
        <div class="videoWrapper mt-4">
          <iframe
            src="https://player.vimeo.com/video/569433229?autoplay=false&loop=1&title=0&byline=0&portrait=0"
            style="position:absolute;top:0;left:0;width:100%;height:100%;"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="col-md-12 wrapper">
        <h2 class="text-center">How To Use The Enhanced If/Then Capabilities within Automations</h2>
        <div class="videoWrapper mt-4">
          <iframe
            src="https://player.vimeo.com/video/552967745?autoplay=false&loop=1&title=0&byline=0&portrait=0"
            style="position:absolute;top:0;left:0;width:100%;height:100%;"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="col-md-12 wrapper">
        <h2 class="text-center">How To Import A Business Funnel or Single Automation</h2>
        <div class="videoWrapper mt-4">
          <iframe
            src="https://player.vimeo.com/video/564742322?autoplay=false&loop=1&title=0&byline=0&portrait=0"
            style="position:absolute;top:0;left:0;width:100%;height:100%;"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="col-md-12 wrapper">
        <h2 class="text-center">How To Share Links With Automation</h2>
        <div class="videoWrapper mt-4">
          <iframe
            src="https://player.vimeo.com/video/536859466?autoplay=false&loop=1&title=0&byline=0&portrait=0"
            style="position:absolute;top:0;left:0;width:100%;height:100%;"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="col-md-12 wrapper">
        <h2 class="text-center">How To Enable Two-Way Texting</h2>
        <div class="videoWrapper mt-4">
          <iframe
            src="https://player.vimeo.com/video/579998677?autoplay=false&loop=1&title=0&byline=0&portrait=0"
            style="position:absolute;top:0;left:0;width:100%;height:100%;"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="col-md-12 wrapper">
        <h2 class="text-center">How to Update Your Payment Account</h2>
        <div class="videoWrapper mt-4">
          <iframe
            src="https://player.vimeo.com/video/568618245?autoplay=false&loop=1&title=0&byline=0&portrait=0"
            style="position:absolute;top:0;left:0;width:100%;height:100%;"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="col-md-12 wrapper">
        <h2 class="text-center">Viral Loops And Gamification Demo</h2>
        <div class="videoWrapper mt-4">
          <iframe
            src="https://player.vimeo.com/video/654744138?autoplay=false&loop=1&title=0&byline=0&portrait=0"
            style="position:absolute;top:0;left:0;width:100%;height:100%;"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
}
</script>

<style lang="scss">
.trainingPage {
  .wrapper {
    margin-top: 100px;
  }
  .videoWrapper {
    height: 400px;
    max-width: 680px;
    width: 90vw;
    margin: auto;
    position: relative;
    // border:15px solid #333;
    // -webkit-box-shadow: 0px 0px 10px 10px rgba(0, 0, 0, 0.15);
    // box-shadow: 0px 0px 10px 10px rgba(0, 0, 0, 0.15);
    // border-radius: 10px;
  }
}
</style>
